import { Injectable } from '@angular/core';
import { RestService } from '../../../core/service/rest.service';
import { UserInteractionAPIConstant} from '../constant/user-interactions.constant';

@Injectable({
  providedIn: 'root'
})
export class UserInteractionsService {
 

  constructor(private rest: RestService) { }
  getChart(payload: any,Isvariant:boolean) { return this.rest.get(UserInteractionAPIConstant.PVPieChart+`?Isvariant=${Isvariant}`, payload)}
  gettopUserInteractions(payload: any,Isvariant:boolean) { return this.rest.get(UserInteractionAPIConstant.topUserInteractions+`?Isvariant=${Isvariant}`, payload)}
  getUserInteractionsPVOrReportsTableData(payload: any,Isvariant:boolean){ return this.rest.post(UserInteractionAPIConstant.UserInteractionsPVOrReportsTableData+`?Isvariant=${Isvariant}`, payload, { 'Content-Type': 'multipart/form-data'}) }
}
